import React, { forwardRef, useContext, useRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { ThemeContext } from "../Theme";
import { EqualHeight } from "../EqualHeight/EqualHeight";

import { LinkListProvider } from "./LinkListContext";
import LinkListColumn from "./LinkListColumn";
import LinkListCategory from "./LinkListCategory";
import LinkListLinks from "./LinkListLinks";
import LinkListInlineLinks from "./LinkListInlineLinks";
import LinkListLink from "./LinkListLink";

import styles from "./LinkList.scss";

export const LinkList = forwardRef(({ children }, ref) => {
  const context = useContext(ThemeContext);
  const columnCounter = useRef(0);

  let theme = "";

  if (context) {
    theme += styles[context];
  }

  return (
    <LinkListProvider
      value={{
        columnIncrementer: () => {
          const previousColumnCount = columnCounter.current;
          columnCounter.current += 1;
          return previousColumnCount;
        },
      }}
    >
      <div ref={ref} className={cx(styles.linkList, theme)}>
        <EqualHeight>{children}</EqualHeight>
      </div>
    </LinkListProvider>
  );
});

LinkList.Column = LinkListColumn;
LinkList.Category = LinkListCategory;
LinkList.Links = LinkListLinks;
LinkList.InlineLinks = LinkListInlineLinks;
LinkList.Link = LinkListLink;

LinkList.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

LinkList.displayName = "LinkList";

export default LinkList;
